(function () {
  'use strict';

  // ── Mobile nav ──────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var hamburger = document.querySelector('.hamburger');
    var mobileNav = document.querySelector('.mobile-nav');
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('open');
        hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  });

  // ── Cart ────────────────────────────────────────────────
  // Two modes:
  //   - 'drawer' : AJAX add, slide-in drawer with line item management
  //   - 'page'   : AJAX add for instant feedback, then redirect to /cart
  //                (qty/remove on the cart page reload the page)
  var Cart = {
    drawer: null,
    panel: null,
    body: null,

    isDrawer: function () {
      return (window.shop && window.shop.cartType === 'drawer') && !!this.drawer;
    },

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (this.drawer) {
        this.panel = this.drawer.querySelector('.cart-drawer-panel');
        this.body = this.drawer.querySelector('[data-cart-drawer-body]');
        this.bindDrawerEvents();
      }
      // Always bind global events (qty controls work on the cart page too)
      this.bindGlobalEvents();
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      // Force layout so the transition applies
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      var d = this.drawer;
      setTimeout(function () { d.hidden = true; }, 250);
    },

    bindGlobalEvents: function () {
      if (this.__globalBound) return;
      this.__globalBound = true;
      var self = this;

      // Header link — only hijack in drawer mode; otherwise let it navigate to /cart
      document.addEventListener('click', function (e) {
        if (!self.isDrawer()) return;
        var headerCart = e.target.closest('.header-cart, [data-cart-open]');
        if (headerCart && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          self.open();
        }
      });

      // Submit add-to-cart forms asynchronously
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[action$="/cart/add"], form#product-form');
        if (!form) return;
        e.preventDefault();
        self.handleAdd(form);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer && self.drawer.classList.contains('is-open')) {
          self.close();
        }
      });

      // Line item qty +/- (drawer or page)
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-line]');
        if (!btn) return;
        var key = btn.getAttribute('data-qty-line');
        var dir = parseInt(btn.getAttribute('data-qty-direction'), 10);
        var input = document.querySelector('[data-qty-input="' + key + '"]');
        if (!input) return;
        var next = Math.max(0, parseInt(input.value, 10) + dir);
        input.value = next;
        self.updateLine(key, next);
      });

      // Direct qty input change
      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (input) {
          var key = input.getAttribute('data-qty-input');
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          self.updateLine(key, qty);
        }
      });

      // Remove line
      document.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-line-remove]');
        if (rm) {
          e.preventDefault();
          self.updateLine(rm.getAttribute('data-line-remove'), 0);
        }
      });

      // Product page +/- buttons (pre-add)
      document.addEventListener('click', function (e) {
        var dec = e.target.closest('[data-qty-decrease]');
        var inc = e.target.closest('[data-qty-increase]');
        if (!dec && !inc) return;
        var input = (dec || inc).closest('.qty-input').querySelector('input');
        if (!input) return;
        var cur = parseInt(input.value, 10) || 1;
        input.value = dec ? Math.max(1, cur - 1) : cur + 1;
      });
    },

    bindDrawerEvents: function () {
      if (this.__drawerBound) return;
      this.__drawerBound = true;
      var self = this;
      this.drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-drawer-close]')) {
          self.close();
        }
      });
    },

    handleAdd: function (form) {
      var self = this;
      var button = form.querySelector('[data-add-to-cart]');
      var label = button && button.querySelector('[data-add-to-cart-text]');
      var originalLabel = label && label.textContent;
      if (button) { button.disabled = true; }
      if (label) { label.textContent = 'Adding…'; }

      var formData = new FormData(form);
      if (self.isDrawer()) {
        formData.append('sections', 'cart-drawer');
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (label) { label.textContent = (res.data && res.data.description) || 'Unable to add'; }
            setTimeout(function () { if (label) label.textContent = originalLabel; }, 2000);
            return;
          }
          if (self.isDrawer()) {
            if (label) { label.textContent = 'Added ✓'; }
            self.refreshDrawer().then(function () { self.open(); });
            self.refreshCount();
            setTimeout(function () { if (label) label.textContent = originalLabel; }, 1500);
          } else {
            // Page mode — redirect to /cart so the user sees their updated cart
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(function () {
          if (label) { label.textContent = 'Error — try again'; }
          setTimeout(function () { if (label) label.textContent = originalLabel; }, 2000);
        })
        .finally(function () {
          if (button) { button.disabled = false; }
        });
    },

    updateLine: function (key, quantity) {
      var self = this;
      var body = { id: key, quantity: quantity };
      if (self.isDrawer()) body.sections = 'cart-drawer';

      return fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (self.isDrawer()) self.refreshDrawer();
          self.refreshCount();
          // If on cart page, reload to reflect server-side totals/discounts
          var cartPage = document.querySelector('[data-cart-page]');
          if (cartPage) {
            location.reload();
          }
        });
    },

    refreshDrawer: function () {
      var self = this;
      if (!this.body) return Promise.resolve();
      return fetch('?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBody = doc.querySelector('[data-cart-drawer-body]');
          if (newBody) { self.body.innerHTML = newBody.innerHTML; }
        });
    },

    refreshCount: function () {
      fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
    }
  };

  // ── Product variant picker ──────────────────────────────
  var Product = {
    init: function () {
      var section = document.querySelector('[data-product-section]');
      if (!section) return;
      var dataScript = section.querySelector('[data-product-json]');
      if (!dataScript) return;

      try {
        this.product = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }
      this.section = section;
      this.idInput = section.querySelector('[data-variant-id-input]');
      this.priceWrap = section.querySelector('[data-price-wrap]');
      this.skuEl = section.querySelector('[data-variant-sku]');
      this.addBtn = section.querySelector('[data-add-to-cart]');
      this.addBtnText = section.querySelector('[data-add-to-cart-text]');

      this.bind();
      this.bindMedia();
    },

    bind: function () {
      var self = this;
      this.section.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-input]')) return;
        self.updateSelected();
      });
    },

    bindMedia: function () {
      var self = this;
      this.section.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-media-target]');
        if (!thumb) return;
        var id = thumb.getAttribute('data-media-target');
        self.section.querySelectorAll('.product-media-slide').forEach(function (slide) {
          var match = slide.getAttribute('data-media-id') === id;
          slide.hidden = !match;
          slide.classList.toggle('is-active', match);
        });
        self.section.querySelectorAll('[data-media-target]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    },

    updateSelected: function () {
      var inputs = this.section.querySelectorAll('[data-option-input]:checked');
      var values = Array.prototype.map.call(inputs, function (i) { return i.value; });

      var variant = this.product.variants.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === values[idx]; });
      });

      // Update visible "selected" labels
      this.section.querySelectorAll('.product-option').forEach(function (fs, idx) {
        var sel = fs.querySelector('[data-option-selected]');
        if (sel && values[idx] !== undefined) sel.textContent = values[idx];
      });

      if (!variant) {
        if (this.addBtn) {
          this.addBtn.disabled = true;
          this.addBtn.setAttribute('aria-disabled', 'true');
        }
        if (this.addBtnText) this.addBtnText.textContent = 'Unavailable';
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.skuEl) this.skuEl.textContent = variant.sku || '';

      if (this.priceWrap) {
        this.priceWrap.innerHTML = this.renderPrice(variant);
      }

      if (this.addBtn) {
        this.addBtn.disabled = !variant.available;
        this.addBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      }
      if (this.addBtnText) {
        this.addBtnText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      // Update URL with ?variant=
      if (history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      // Switch media to variant's featured image
      if (variant.featured_media) {
        var id = String(variant.featured_media.id);
        var slide = this.section.querySelector('[data-media-id="' + id + '"]');
        var thumb = this.section.querySelector('[data-media-target="' + id + '"]');
        if (slide) {
          this.section.querySelectorAll('.product-media-slide').forEach(function (s) {
            s.hidden = (s !== slide);
            s.classList.toggle('is-active', s === slide);
          });
        }
        if (thumb) {
          this.section.querySelectorAll('[data-media-target]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        }
      }
    },

    renderPrice: function (variant) {
      var money = function (cents) { return formatMoney(cents); };
      var html = '<span class="price price--lg' + (variant.compare_at_price > variant.price ? ' price--on-sale' : '') + '">';
      html += '<span class="price-current">' + money(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="price-compare"><s>' + money(variant.compare_at_price) + '</s></span>';
        html += '<span class="price-discount">−' + pct + '%</span>';
      }
      html += '</span>';
      return html;
    }
  };

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    var value = (parseFloat(cents) / 100).toFixed(2);
    var fmt = (window.shop && window.shop.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator|_with_apostrophe_separator)?\s*\}\}/g, function () {
      return value;
    });
  }

  // ── Related products (recommendations endpoint) ────────
  function loadRecommendations() {
    var placeholder = document.querySelector('[data-recommendations][data-recommendations-url]');
    if (!placeholder) return;
    fetch(placeholder.dataset.recommendationsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-recommendations]');
        if (content) placeholder.outerHTML = content.outerHTML;
      })
      .catch(function () {});
  }

  // ── Country/province selector ──────────────────────────
  function initCountryProvince() {
    document.querySelectorAll('select[name="address[country]"]').forEach(function (countrySel) {
      var defaultCountry = countrySel.getAttribute('data-default');
      if (defaultCountry) {
        var opt = countrySel.querySelector('option[value="' + defaultCountry + '"]');
        if (opt) opt.selected = true;
      }
      var wrap = countrySel.closest('.form-row--double, .form-row');
      var provinceWrap = wrap && wrap.querySelector('[data-province-wrap]');
      var provinceSel = provinceWrap && provinceWrap.querySelector('select[name="address[province]"]');

      function updateProvinces() {
        if (!provinceSel) return;
        var selected = countrySel.options[countrySel.selectedIndex];
        var provincesRaw = selected.getAttribute('data-provinces');
        var provinces = [];
        try { provinces = JSON.parse(provincesRaw || '[]'); } catch (e) {}
        if (!provinces.length) {
          provinceWrap.style.display = 'none';
          provinceSel.innerHTML = '';
          return;
        }
        provinceWrap.style.display = '';
        var defaultProvince = provinceSel.getAttribute('data-default');
        provinceSel.innerHTML = provinces.map(function (p) {
          return '<option value="' + p[0] + '"' + (p[0] === defaultProvince ? ' selected' : '') + '>' + p[1] + '</option>';
        }).join('');
      }

      countrySel.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }

  // ── Predictive search ──────────────────────────────────
  var PredictiveSearch = {
    minChars: 2,
    debounceMs: 200,

    init: function () {
      var wraps = document.querySelectorAll('[data-predictive-search]');
      var self = this;
      wraps.forEach(function (wrap) { self.bindWrap(wrap); });
      this.bindGlobal();
    },

    bindWrap: function (wrap) {
      if (wrap.__predictiveBound) return;
      wrap.__predictiveBound = true;

      var input = wrap.querySelector('[data-predictive-search-input]');
      var content = wrap.querySelector('[data-predictive-search-content]');
      var loading = wrap.querySelector('[data-predictive-loading]');
      if (!input || !content) return;

      var self = this;
      var timer = null;
      var lastTerm = '';
      var controller = null;

      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < self.minChars) {
          self.hide(wrap);
          lastTerm = '';
          return;
        }
        if (term === lastTerm) return;
        timer = setTimeout(function () {
          lastTerm = term;
          if (controller && controller.abort) controller.abort();
          controller = (window.AbortController) ? new AbortController() : null;
          self.fetch(term, controller, content, loading, wrap);
        }, self.debounceMs);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= self.minChars && content.innerHTML.trim()) {
          self.show(wrap);
        }
      });
    },

    bindGlobal: function () {
      if (this.__globalBound) return;
      this.__globalBound = true;
      var self = this;
      document.addEventListener('click', function (e) {
        document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
          if (!wrap.contains(e.target)) self.hide(wrap);
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
            self.hide(wrap);
            var input = wrap.querySelector('[data-predictive-search-input]');
            if (input) input.blur();
          });
        }
      });
    },

    fetch: function (term, controller, content, loading, wrap) {
      var url = window.routes.predictive_search_url
        + '?q=' + encodeURIComponent(term)
        + '&section_id=predictive-search'
        + '&resources[type]=product,collection,page,article,query'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,vendor,product_type,tag';

      var opts = { headers: { 'Accept': 'text/html' } };
      if (controller) opts.signal = controller.signal;

      var self = this;
      if (loading) loading.hidden = false;
      this.show(wrap);

      fetch(url, opts)
        .then(function (r) {
          if (!r.ok) throw new Error('predictive request failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('.predictive-results');
          content.innerHTML = results ? results.outerHTML : '';
          if (loading) loading.hidden = true;
          self.show(wrap);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (loading) loading.hidden = true;
        });
    },

    show: function (wrap) {
      var dropdown = wrap.querySelector('[data-predictive-search-results]');
      if (dropdown) dropdown.hidden = false;
    },

    hide: function (wrap) {
      var dropdown = wrap.querySelector('[data-predictive-search-results]');
      if (dropdown) dropdown.hidden = true;
    }
  };

  // Auto-submit any [data-auto-submit] control when changed
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (el && el.form) el.form.submit();
  });

  // Terms acceptance gate on the cart page: toggle checkout button on checkbox change
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-cart-terms-checkbox]');
    if (!cb) return;
    var form = cb.closest('form') || document;
    var btn = form.querySelector('[data-checkout-btn]');
    if (!btn) return;
    if (cb.checked) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    } else {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
    }
  });

  // ── Price ticker: seamless infinite scroll at constant pixel speed ──
  function initTicker(ticker) {
    var track = ticker.querySelector('[data-ticker-track]');
    if (!track || track.__inited) return;
    track.__inited = true;

    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;

    // Liquid duplicates items 2x. Half of children == one set.
    var perSet = items.length / 2;
    var firstSet = items.slice(0, perSet);

    function measureSetWidth() {
      var w = 0;
      for (var i = 0; i < perSet; i++) {
        w += firstSet[i].offsetWidth;
      }
      return w;
    }

    function setup() {
      // Reset any clones added on a previous measurement (e.g. on resize).
      while (track.children.length > items.length) {
        track.removeChild(track.lastChild);
      }

      var setWidth = measureSetWidth();
      if (setWidth === 0) return;

      // For seamless: track must extend past viewport even after scrolling one set.
      // I.e. total content (N sets) ≥ viewport + one set → N ≥ viewport/setWidth + 1.
      var viewport = ticker.offsetWidth;
      var requiredSets = Math.ceil(viewport / setWidth) + 1;
      var currentSets = 2;
      for (var s = currentSets; s < requiredSets; s++) {
        firstSet.forEach(function (item) { track.appendChild(item.cloneNode(true)); });
      }

      // Constant px/s regardless of item count: duration = setWidth / speed.
      var speed = parseFloat(track.getAttribute('data-ticker-speed')) || 80;
      var duration = setWidth / speed;
      track.style.setProperty('--ticker-shift', '-' + setWidth + 'px');
      track.style.setProperty('--ticker-duration', duration + 's');
    }

    // Recompute on resize (debounced).
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 200);
    });

    // Wait one frame so images have layout.
    requestAnimationFrame(setup);
  }

  function initAllTickers() {
    document.querySelectorAll('[data-ticker]').forEach(initTicker);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.init();
    Product.init();
    PredictiveSearch.init();
    loadRecommendations();
    initCountryProvince();
    initAllTickers();
  });

  // Listen for editor section reloads
  document.addEventListener('shopify:section:load', function () {
    Cart.init();
    Product.init();
    PredictiveSearch.init();
    initCountryProvince();
    initAllTickers();
  });
})();
